import { ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { Observable, forkJoin } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ProduktinstruktionService } from "../services/produktinstruktion.service";

@Component({
    selector: "rask-produktinstruktioner-download",
    templateUrl: "./produktinstruktioner-download.component.html",
    styleUrls: ["./produktinstruktioner-download.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        RadiobuttonGroupComponent,
        ButtonComponent
    ]
})
export class ProduktinstruktionerDownloadComponent {
    filnamnPrefix: string;
    violklass: string;
    violklasser: IRadiobuttonItem[];

    @Input() getFileName: (puid: string) => string;

    @Input() getSelectedPuids: () => string[];

    private readonly busyService = inject(BusyService);
    private readonly produktinstruktionService = inject(ProduktinstruktionService);

    constructor() {
        this.violklasser = [
            { key: "Viol2",
                value: "Viol2" },
            { key: "Viol3",
                value: "Viol3" }
        ] as IRadiobuttonItem[];
        this.violklass = "Viol3";
        this.filnamnPrefix = "";
    }

    download(format: "combinedpin" | "env" | "singlepin"): void {
        const selection = this.getSelectedPuids();
        let worker: Observable<any>;
        if (format === "singlepin") {
            worker = new Observable(observer => {
                const observables = [];
                selection.forEach(puid => {
                    const filename = ObjectUtils.stringHasValue(this.filnamnPrefix) ?
                        `${this.filnamnPrefix}_${this.getFileName(puid)}_${puid}` : `${this.getFileName(puid)}_${puid}`;
                    observables.push(this.produktinstruktionService.download([puid], this.violklass === "Viol3", format, filename));
                });

                // eslint-disable-next-line sonarjs/deprecation
                forkJoin(observables)
                    .subscribe(() => {
                        observer.next(true);
                        observer.complete();
                    });
            });
        } else {
            worker = this.produktinstruktionService.download(selection, this.violklass === "Viol3", format, `${this.filnamnPrefix}rask`);
        }

        this.busyService.addWork(worker).subscribe();
    }
}
